import { FormHelperText, Grid, Stack, TextField } from "@mui/material";
import { useState } from "react";

interface Props {
  value?: string | null;
  name: string;
  label?: string;
  onChange: (value: string) => void;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  onBlur?: () => void;
}

export const ColorPicker = ({
  value,
  name,
  label,
  onChange,
  helperText,
  error,
  disabled,
  onBlur,
}: Props) => {
  const [color, setColor] = useState(value || "#000000");

  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.value = event.target.value.substring(0, 7);
    const value = event.target.value;
    setColor(value);
    onChange(value);
  };

  return (
    <Stack>
      <Grid container>
        <Grid item xs={8}>
          <TextField
            fullWidth
            disabled={disabled}
            name={name}
            label={label}
            variant="outlined"
            type="text"
            value={color}
            onChange={handleColorChange}
            sx={{ border: "none" }}
            onBlur={onBlur}
          />
        </Grid>

        <Grid item xs={4}>
          <input
            name={name}
            type="color"
            disabled={disabled}
            value={color}
            onChange={handleColorChange}
            onBlur={onBlur}
            style={{
              borderRadius: "0px 5px 5px 0px",
              width: "100%",
              height: "100%",
              padding: "0px",
              margin: "0px",
              border: "none",
              backgroundColor: color,
              overflow: "hidden",
              cursor: "pointer",
            }}
          />
        </Grid>
      </Grid>

      <FormHelperText error={error}>{helperText}</FormHelperText>
    </Stack>
  );
};
